import { Dialog } from '@mui/material'
const ImagePreviewDialog = ({ open, onClose, imageUrl }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <img
        src={imageUrl}
        alt="Preview"
        style={{ maxWidth: '100%', maxHeight: '80vh' }}
      />
    </Dialog>
  )
}

export default ImagePreviewDialog
